<template>
  <div>
    <div class="main" :class="isActive ? 'nativeOuter' : ''">
      <div class="left">
        <div class="leftItem" @click="$store.commit('setCpTabIndex',0)">
          园测信科产品线
        </div>
        <div class="line"></div>
        <div class="leftItem" @click="$store.commit('setCpTabIndex',1)">
          整体解决方案

        </div>
        <div class="line"></div>
        <div class="leftItem" @click="$store.commit('setCpTabIndex',2)">
          开发区经验输出

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductProgrammeList } from "@/api/solutio.js";
export default {
  name: "HeaderHover",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["reload"],
  data() {
    return {
      mapmostList: [],
      mapmostListIndex: "",
      mapmostData: [],

      titleList: [],
      titleListIndex: "",
      titleData: [],

      titleListSecond: [],
      titleListSecondIndex: "",
      titleListSecondData: [],
    };
  },
  mounted() {
    (this.mapmostList = []), (this.titleList = []), (this.titleListSecond = []);
    getProductProgrammeList({ isRelease: 1 }).then((res) => {
      res.data.forEach((e, index) => {
        if (e.name == "园测信科产品线") {
          e.childrenList = e.childrenList || [];
          this.mapmostListIndex = index;
          this.mapmostData = e.childrenList;
          e.childrenList.forEach((obj) => {
            this.mapmostList.push(obj.name);
          });
        }
        if (e.name == "整体解决方案") {
          e.childrenList = e.childrenList || [];
          this.titleListIndex = index;
          this.titleData = e.childrenList;
          e.childrenList.forEach((obj) => {
            this.titleList.push(obj.name);
          });
        }
        if (e.name == "开发区经验输出") {
          e.childrenList = e.childrenList || [];
          this.titleListSecondIndex = index;
          this.titleListSecondData = e.childrenList;
          e.childrenList.forEach((obj) => {
            this.titleListSecond.push(obj.name);
          });
        }
      });
    });
  },
  methods: {
    clickMap() { },
    toMapmost(url) {
      window.open(url);
    },

    // pdfUrl (pdf = "", url = "", type = "", obj, orname, scname) {
    //   console.log(obj)
    //   if (obj.urlType == 4) {

    //     this.$router.replace({
    //       path: '/pageTemplate',
    //       query: {
    //         data: JSON.stringify(
    //           obj
    //         ),
    //         orname: orname,
    //         scname: scname
    //       }
    //     })
    //     return
    //   }
    //   let d = new Date()
    //   if (pdf.indexOf('.pdf') > -1) {
    //     this.reload()
    //     this.$router.push({ path: '/pdfFile', query: { name: pdf, url: url, type: type, t: d.getTime() } });
    //   } else {
    //     window.open(pdf)
    //   }

    // },
    pdfUrl(pdf = "", url = "", type = "", obj, orname, scname) {
      let d = new Date();

      if (obj.urlType == 4) {
        this.$router.push({
          path: "/pageTemplate",
          query: {
            data: JSON.stringify(obj),
            orname: orname,
            scname: scname,
          },
        });

        return;
      }

      if (pdf.indexOf(".pdf") > -1 && pdf.endsWith(".pdf")) {
        this.$router.push({
          path: "/productPdf",
          query: {
            name: pdf,
            url: url,
            type: type,
            productName: obj.name,
            parentId: obj.parentId,
            objId: obj.id,
            t: d.getTime(),
          },
        });
      } else if (pdf.indexOf(".html") || pdf.indexOf("/#/")) {
        window.open(pdf);
      } else {
        this.$router.push({
          path: "/productPdf",
          query: {
            name: pdf,
            url: url,
            type: type,
            productName: obj.name,
            parentId: obj.parentId,
            objId: obj.id,
            t: d.getTime(),
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background: rgba($color: #000712, $alpha: 0.8);
  border-radius: 0px 0px 6px 6px;
  display: flex;
  position: relative;

  .left {
    display: flex;
    flex-direction: column;
    width: 226px;
    border-right: 1px solid rgba($color: #fff, $alpha: 0.5);

    .leftItem {
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #eee;
      flex: 1;
      padding: 10px 0;
    }

    .right {
      display: none;
      position: absolute;
      left: 167px;
      top: 0;
      background: rgba($color: #000712, $alpha: 0.8);
      border-radius: 0px 0px 6px 6px;
      // animation: fadeInLeft; /* referring directly to the animation's @keyframe declaration */
      // animation-duration: 0.5s; /* don't forget to set a duration! */
      animation: showRightCon 1s ease-in-out;
      overflow: hidden;
    }

    .flexwidMost {
      >div {
        flex-shrink: 0;

        &:nth-child(1) {
          width: 150px;
        }

        &:nth-child(2) {
          width: 150px;
        }

        &:nth-child(3) {
          width: 220px;
        }

        &:nth-child(4) {
          width: 150px;
        }

        &:nth-child(5) {
          width: 150px;
        }
      }
    }

    .flexwid {
      >div {
        flex-shrink: 0;

        &:nth-child(1) {
          width: 160px;
        }

        &:nth-child(2) {
          width: 160px;
        }

        &:nth-child(3) {
          width: 160px;
        }

        &:nth-child(3) {
          width: 160px;
        }
      }
    }

    .flexwid3 {
      >div {
        flex-shrink: 0;

        &:nth-child(1) {
          width: 180px;
        }

        &:nth-child(2) {
          width: 160px;
        }

        &:nth-child(3) {
          width: 100px;
        }

        &:nth-child(4) {
          width: 130px;
        }
      }
    }

    .right_first {
      animation: showRightConFirst 0.5s ease-in-out;
    }

    .right_third {
      animation: showRightConThird 1s ease-in-out;
    }

    .leftItem:hover {
      color: #003889;
      font-weight: 600;

      .right {
        display: block;
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background: rgba($color: #fff, $alpha: 0.3);
    }
  }

  .right {
    // width: 788px;
    min-height: 240px;
    color: #eee;

    .title {
      display: flex;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.3);
      line-height: 50px;

      .titleItem {
        text-align: left;
        margin-left: 10px;
      }
    }

    .content {
      display: flex;

      .contentItem {
        // flex: 1;
        margin-left: 10px;
        z-index: 99;

        .item {
          line-height: 20px;
          width: 100%;
          min-width: 150px;
          opacity: 0.8;
          white-space: normal;
          word-break: break-word;
          padding: 10px 0;
          text-align: left;
          cursor: pointer;
          color: #fff;
          font-size: 14px;
        }

        .btnItem {
          .item {
            display: none;
          }
        }

        .btnItem:hover {
          .item {
            display: block;
          }
        }

        .item:hover {
          font-weight: 900;
        }
      }

      .btnHide {
        display: none;
      }
    }
  }
}

.nativeOuter {
  background: #fff;
  box-shadow: 0px 4px 8px 0px rgba(5, 28, 55, 0.42);

  .left {
    border-right: 1px solid rgba($color: #333, $alpha: 0.3);

    .leftItem {
      color: #333;
    }

    .line {
      background: rgba($color: #333, $alpha: 0.3);
    }

    .right {
      background: #fff;
      box-shadow: 0px 4px 8px 0px rgba(5, 28, 55, 0.42);
    }
  }

  .right {
    .title {
      border-bottom: 1px solid rgba($color: #333, $alpha: 0.3);

      .titleItem {
        color: #333;
      }
    }

    .content {
      .contentItem {
        .item {
          color: #333;
        }
      }
    }
  }
}</style>
